import Seo from "../components/Seo";
import Breadcrumbs from "../components/Breadcrumbs";
import { Reveal } from "../components/Motion";

export default function About() {
    return (
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10" data-testid="about-page">
            <Seo title="About Us" description="The Puro Pack is a sustainable paper packaging manufacturer based in Bangalore — a Green Technology partner to foodservice brands worldwide." path="/about" />
            <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "About", to: "/about" }]} />

            <section className="pt-16 pb-24 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-7">
                    <div className="font-mono text-xs uppercase tracking-widest text-clay mb-6">[ Chapter 00 · Origin ]</div>
                    <h1 className="font-serif text-6xl lg:text-8xl leading-[0.95] tracking-tight text-forest">A <em className="italic">Food Packaging</em> Manufacturer with the agility of a startup.</h1>
                </div>
                <div className="lg:col-span-5 lg:pt-24">
                    <p className="text-lg text-inkgreen/80 leading-relaxed">
                        The Puro Pack is a sustainable paper packaging manufacturer headquartered in Bangalore. We started in 2025 with a simple thesis: if we made the transition off plastic <em>easier</em> than staying on it, foodservice would follow.
                    </p>
                </div>
            </section>

            <section className="border-t border-forest/30 py-24 grid lg:grid-cols-12 gap-10">
                <div className="lg:col-span-5">
                    <div className="image-frame aspect-[4/5]">
                        <img src="https://customer-assets-v7afamib.emergentagent.net/job_eco-pack-portal-1/artifacts/jfii9597_AdobeStock_579011444.webp" alt="Kraft paper bowls filled with rice, chicken, mushrooms and vegetables — sustainable packaging by The Puro Pack" loading="lazy" />
                    </div>
                </div>
                <div className="lg:col-span-7">
                    {[
                        { n: "01", h: "Green Technology, in practice.", b: "We use food-safe PE coatings and water-based Aqueous coatings on paper bowls and containers — matched to the temperature, shelf-life and end-of-life of your kitchen. Every technology choice on our floor is auditable against a single question — is this the most responsible option for the product's job?" },
                        { n: "02", h: "Manufactured in Bangalore.", b: "Our facility in Bangalore houses dedicated coating, forming, printing and finishing lines. We ship domestically within 5 days and internationally within 14." },
                        { n: "03", h: "Built to travel.", b: "Food-safe products aligned with FSSAI and international food-contact standards. Compostable board options available for cold formats. Export-ready to global markets." },
                    ].map((s) => (
                        <div key={s.n} className="border-t border-forest/30 py-10">
                            <div className="font-mono text-3xl text-clay mb-3">[{s.n}]</div>
                            <h3 className="font-serif text-3xl text-forest tracking-tight mb-3">{s.h}</h3>
                            <p className="text-inkgreen/80 leading-relaxed">{s.b}</p>
                        </div>
                    ))}
                </div>
            </section>

            <Reveal>
                <section className="py-24 border-t border-forest/30">
                    <div className="grid md:grid-cols-4 gap-8">
                        {[
                            ["2025", "Founded, Bangalore"],
                            ["4", "Product families"],
                            ["7", "SKUs, at launch"],
                            ["100%", "Food-safe coatings"],
                        ].map(([k, v]) => (
                            <div key={k}>
                                <div className="font-serif text-6xl text-forest">{k}</div>
                                <div className="font-mono text-xs uppercase tracking-widest text-stone mt-2">{v}</div>
                            </div>
                        ))}
                    </div>
                </section>
            </Reveal>
        </div>
    );
}
